/** Лимиты веса по ТК: { "яндекс доставка": 20, "почта россии": 20 } (кг). */
export type WeightLimitByTk = Record<string, number>;

/** Парсинг списков ТК из CONFIG доставки (через запятую). */
export function parseTkList(configValue?: string): string[] {
  if (!configValue?.trim()) {
    return [];
  }
  return configValue
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
}

/** Совпадение выбранного ПВЗ (POINT_INFO) с одной из подстрок ТК. */
export function pointInfoMatchesTkList(
  pointInfo: string | undefined,
  tkList: string[],
): boolean {
  if (!pointInfo?.trim() || !tkList.length) {
    return false;
  }
  const lower = pointInfo.toLowerCase();
  return tkList.some((tk) => lower.includes(tk.toLowerCase()));
}

/** Вес корзины в кг (ORDER_WEIGHT с бэка — граммы). */
export function getBasketWeightKg(basket: { ORDER_WEIGHT?: number }): number {
  return (Number(basket?.ORDER_WEIGHT) || 0) / 1000;
}

/** Формат CONFIG: "яндекс доставка:20,почта россии:20" (вес в кг). */
export function parseWeightLimitTkList(configValue?: string): WeightLimitByTk {
  const limits: WeightLimitByTk = {};
  if (!configValue?.trim()) {
    return limits;
  }
  configValue.split(",").forEach((pair) => {
    const [tkRaw, limitRaw] = pair.split(":");
    const tk = tkRaw?.trim();
    const limitKg = Number(limitRaw?.trim());
    if (tk && limitKg > 0) {
      limits[tk] = limitKg;
    }
  });
  return limits;
}

/** Лимит в кг для тарифа по подстроке имени ТК в объекте лимитов. */
export function getWeightLimitKgForTarif(
  tarifName: string,
  weightLimits: WeightLimitByTk,
): number | undefined {
  const lower = tarifName.toLowerCase();
  for (const [tk, limitKg] of Object.entries(weightLimits)) {
    if (lower.includes(tk.toLowerCase())) {
      return limitKg;
    }
  }
  return undefined;
}

/**
 * Тариф недоступен по весу (true — скрываем на карте).
 * ТК нет в объекте лимитов — false (лимит не задан, тариф доступен).
 * ТК есть в объекте — true, если вес корзины больше лимита из объекта.
 */
export function isTarifDisabledByWeight(
  tarifName: string,
  basketWeightKg: number,
  weightLimits: WeightLimitByTk,
): boolean {
  const limitKg = getWeightLimitKgForTarif(tarifName, weightLimits);

  if (limitKg === undefined) {
    return false;
  }

  return basketWeightKg > limitKg;
}

export const PASSPORT_SERIES_NUMBER_LENGTH = 9;

export function normalizePassportDigits(value?: string): string {
  return String(value ?? "")
    .replace(/\D/g, "")
    .slice(0, PASSPORT_SERIES_NUMBER_LENGTH);
}

export function isPassportValueValid(passportRaw?: string): boolean {
  return (
    normalizePassportDigits(passportRaw).length ===
    PASSPORT_SERIES_NUMBER_LENGTH
  );
}
